import { Component, OnInit } from '@angular/core';
import { Company } from '../../classes/company';
import { Department } from '../../classes/department';
import { NgForm } from '@angular/forms';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-add-department-page',
  templateUrl: './add-department-page.component.html',
  styleUrls: ['./add-department-page.component.scss']
})
export class AddDepartmentPageComponent implements OnInit {

  constructor(private titleService: Title) { }

  department: Department = <Department>{};

  ngOnInit() {
      this.titleService.setTitle('Add Department');
  }

  addDepartment(departmentForm: NgForm){
    if (departmentForm.invalid){
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/add-department-page/add-department-page.component.ts